!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define("ati-ui-react", ["react"], t) : "object" == typeof exports ? exports["ati-ui-react"] = t(require("react")) : e["ati-ui-react"] = t(e.React);
}(this, function (n) {
  return i = {}, o.m = r = {
    0: function (e, t) {
      e.exports = n;
    },
    10: function (e, t, n) {
      "use strict";

      n.d(t, "b", function () {
        return r;
      }), n.d(t, "a", function () {
        return o;
      });
      var r = function (t) {
          for (var e = arguments.length, n = Array(1 < e ? e - 1 : 0), r = 1; r < e; r++) n[r - 1] = arguments[r];
          return n.filter(Boolean).map(function (e) {
            return t[e];
          }).join(" ");
        },
        o = function () {
          for (var e = arguments.length, t = Array(e), n = 0; n < e; n++) t[n] = arguments[n];
          return t.filter(Boolean).join(" ");
        };
    },
    199: function (e, t, n) {
      (t = e.exports = n(4)()).push([e.i, '._3d53y-2-0-721{text-align:center;border:0;background:none;color:transparent;outline:0;padding:0;width:100%;height:100%}._3d53y-2-0-721 ._21nSO-2-0-721{display:inline-block;vertical-align:middle;position:relative;width:33.3%;height:33.3%}._3d53y-2-0-721 ._21nSO-2-0-721:after,._3d53y-2-0-721 ._21nSO-2-0-721:before{content:"";position:absolute;width:100%;height:4px;left:0;top:50%;margin-top:-2px;background-color:#949a9f}._3d53y-2-0-721 ._21nSO-2-0-721:after{transform:rotate(45deg)}._3d53y-2-0-721 ._21nSO-2-0-721:before{transform:rotate(-45deg)}._3d53y-2-0-721:hover{cursor:pointer}._3d53y-2-0-721:hover ._21nSO-2-0-721{color:transparent}._3d53y-2-0-721:hover ._21nSO-2-0-721:after,._3d53y-2-0-721:hover ._21nSO-2-0-721:before{border-color:#fff}._3d53y-2-0-721:hover._1A4Dt-2-0-721{background-color:rgba(6,21,35,.6)}', ""]), t.locals = {
        "ati-core-close-button": "_3d53y-2-0-721",
        "cross-button": "_21nSO-2-0-721",
        "with-background": "_1A4Dt-2-0-721"
      };
    },
    2: function (e, t, o) {
      "use strict";

      var n,
        r,
        c = function () {
          return n = void 0 === n ? !(!(window && document && document.all) || window.atob) : n;
        },
        i = (r = {}, function (e) {
          if (void 0 === r[e]) {
            var t = document.querySelector(e);
            if (window.HTMLIFrameElement && t instanceof window.HTMLIFrameElement) try {
              t = t.contentDocument.head;
            } catch (e) {
              t = null;
            }
            r[e] = t;
          }
          return r[e];
        }),
        f = [];
      function l(e) {
        for (var t = -1, n = 0; n < f.length; n++) if (f[n].identifier === e) {
          t = n;
          break;
        }
        return t;
      }
      function u(e, t) {
        for (var n = {}, r = [], o = 0; o < e.length; o++) {
          var i = e[o],
            a = t.base ? i[0] + t.base : i[0],
            c = n[a] || 0,
            u = "".concat(a, " ").concat(c);
          n[a] = c + 1;
          c = l(u), i = {
            css: i[1],
            media: i[2],
            sourceMap: i[3]
          };
          -1 !== c ? (f[c].references++, f[c].updater(i)) : f.push({
            identifier: u,
            updater: function (t, e) {
              var n, r, o;
              {
                var i;
                o = e.singleton ? (i = b++, n = h = h || s(e), r = p.bind(null, n, i, !1), p.bind(null, n, i, !0)) : (n = s(e), r = function (e, t, n) {
                  var r = n.css,
                    o = n.media,
                    n = n.sourceMap;
                  o ? e.setAttribute("media", o) : e.removeAttribute("media");
                  n && "undefined" != typeof btoa && (r += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(n)))), " */"));
                  if (e.styleSheet) e.styleSheet.cssText = r;else {
                    for (; e.firstChild;) e.removeChild(e.firstChild);
                    e.appendChild(document.createTextNode(r));
                  }
                }.bind(null, n, e), function () {
                  !function (e) {
                    if (null === e.parentNode) return;
                    e.parentNode.removeChild(e);
                  }(n);
                });
              }
              return r(t), function (e) {
                e ? e.css === t.css && e.media === t.media && e.sourceMap === t.sourceMap || r(t = e) : o();
              };
            }(i, t),
            references: 1
          }), r.push(u);
        }
        return r;
      }
      function s(e) {
        var t,
          n = document.createElement("style"),
          r = e.attributes || {};
        if (void 0 !== r.nonce || (t = o.nc) && (r.nonce = t), Object.keys(r).forEach(function (e) {
          n.setAttribute(e, r[e]);
        }), "function" == typeof e.insert) e.insert(n);else {
          e = i(e.insert || "head");
          if (!e) throw Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
          e.appendChild(n);
        }
        return n;
      }
      var a,
        d = (a = [], function (e, t) {
          return a[e] = t, a.filter(Boolean).join("\n");
        });
      function p(e, t, n, r) {
        n = n ? "" : r.media ? "@media ".concat(r.media, " {").concat(r.css, "}") : r.css;
        e.styleSheet ? e.styleSheet.cssText = d(t, n) : (r = document.createTextNode(n), (n = e.childNodes)[t] && e.removeChild(n[t]), n.length ? e.insertBefore(r, n[t]) : e.appendChild(r));
      }
      var h = null,
        b = 0;
      e.exports = function (e, i) {
        (i = i || {}).singleton || "boolean" == typeof i.singleton || (i.singleton = c());
        var a = u(e = e || [], i);
        return function (e) {
          if ("[object Array]" === Object.prototype.toString.call(e = e || [])) {
            for (var t = 0; t < a.length; t++) {
              var n = l(a[t]);
              f[n].references--;
            }
            for (var e = u(e, i), r = 0; r < a.length; r++) {
              var o = l(a[r]);
              0 === f[o].references && (f[o].updater(), f.splice(o, 1));
            }
            a = e;
          }
        };
      };
    },
    4: function (e, t) {
      e.exports = function () {
        var a = [];
        return a.toString = function () {
          for (var e = [], t = 0; t < this.length; t++) {
            var n = this[t];
            n[2] ? e.push("@media " + n[2] + "{" + n[1] + "}") : e.push(n[1]);
          }
          return e.join("");
        }, a.i = function (e, t) {
          "string" == typeof e && (e = [[null, e, ""]]);
          for (var n = {}, r = 0; r < this.length; r++) {
            var o = this[r][0];
            "number" == typeof o && (n[o] = !0);
          }
          for (r = 0; r < e.length; r++) {
            var i = e[r];
            "number" == typeof i[0] && n[i[0]] || (t && !i[2] ? i[2] = t : t && (i[2] = "(" + i[2] + ") and (" + t + ")"), a.push(i));
          }
        }, a;
      };
    },
    576: function (e, t, n) {
      "use strict";

      n.r(t), n.d(t, "default", function () {
        return c;
      });
      var r = n(0),
        o = n.n(r),
        i = n(10),
        t = n(2),
        r = n.n(t),
        t = n(199),
        n = n.n(t),
        t = {
          insert: "head",
          singleton: !1
        },
        a = (r()(n.a, t), n.a.locals || {});
      var c = function (e) {
        return o.a.createElement("button", {
          className: Object(i.b)(a, "ati-core-close-button", e.withBackground && "with-background"),
          onClick: e.close
        }, o.a.createElement("div", {
          className: a["cross-button"]
        }));
      };
    }
  }, o.c = i, o.d = function (e, t, n) {
    o.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: n
    });
  }, o.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, o.t = function (t, e) {
    if (1 & e && (t = o(t)), 8 & e) return t;
    if (4 & e && "object" == typeof t && t && t.__esModule) return t;
    var n = Object.create(null);
    if (o.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: t
    }), 2 & e && "string" != typeof t) for (var r in t) o.d(n, r, function (e) {
      return t[e];
    }.bind(null, r));
    return n;
  }, o.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return o.d(t, "a", t), t;
  }, o.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, o.p = "", o(o.s = 576);
  function o(e) {
    if (i[e]) return i[e].exports;
    var t = i[e] = {
      i: e,
      l: !1,
      exports: {}
    };
    return r[e].call(t.exports, t, t.exports, o), t.l = !0, t.exports;
  }
  var r, i;
});